module.exports = __webpack_public_path__ + "img/dlt_kind_2.svg.bak.7fe9d2f6.svg";